import { apiBaseUrl } from '../../configs'

// The single point where a request leaves the UI: prefixes the API base URL and
// attaches the bearer token. Returns the raw Response without inspecting it so
// each caller owns what a failure means — fetchWithAuth throws a generic Error,
// postAction preserves the status and the API's message (see ActionError).
export function apiFetch(
  path: string,
  token: string,
  options?: RequestInit,
): Promise<Response> {
  return fetch(`${apiBaseUrl}${path}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      ...options?.headers,
    },
  })
}
